<div class="modal-header">
  <h2 class="modal-title">Something went wrong</h2>
  <button (click)="dismiss()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true"></span>
  </button>
</div>
<div class="modal-body">
  <div class="alert alert-danger" role="alert">
    Unexpected error occurred.
    <p>Please close this window and try again.</p>
    <p>If this error persists, please contact support:</p>
    <p style="margin-bottom: 2px">
      <i
        aria-hidden="true"
        class="png-icon-micro png-email lg"
        style="color: black"
      >
      </i>
      <span style="padding-left: 10px"
        ><a href="mailto:software.support@pb.com" target="_blank"
          >Email Support</a
        ></span
      >
    </p>
    <p>
      <i
        aria-hidden="true"
        class="png-icon-micro png-monitor lg"
        style="color: black"
      >
      </i>
      <span style="padding-left: 10px"
        ><a href="https://support.precisely.com" rel="noopener" target="_blank"
          >Tech Support & Client Services Contacts</a
        ></span
      >
    </p>
  </div>
  <h3>Support Information</h3>
  <div class="card" style="background-color: #f0f0f0">
    <div class="card-body">
      <div class="contentFix">
        {{ error.stack }}
      </div>
    </div>
  </div>
</div>
<div class="modal-footer"></div>
